import { useLanguage } from "@/context/LanguageContext";
import { MessageCircle, CalendarCheck, BadgeCheck } from "lucide-react";

const How = () => {
  const { t, lang } = useLanguage();
  const steps = t("how.steps") || [];
  const icons = [MessageCircle, CalendarCheck, BadgeCheck];

  return (
    <section
      id="how"
      data-testid="how-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF5A00]">
            {t("how.eyebrow")}
          </div>
          <h2
            className="mt-4 text-4xl md:text-5xl lg:text-6xl font-black tracking-tight text-[#0B1320] leading-[1.05]"
            style={{
              fontFamily:
                lang === "ar" ? "Tajawal, sans-serif" : "Outfit, sans-serif",
            }}
          >
            {t("how.title")}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((s, i) => {
            const Icon = icons[i] || MessageCircle;
            return (
              <div
                key={i}
                data-testid={`how-step-${i + 1}`}
                className="relative bg-[#F3F1E7] rounded-3xl p-8 md:p-10 overflow-hidden group hover:bg-[#0B1320] hover:text-white transition-colors duration-500"
              >
                <div className="flex items-center justify-between">
                  <span
                    className="text-6xl md:text-7xl font-black text-[#0B1320]/10 group-hover:text-white/20 transition-colors leading-none"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    {s.n}
                  </span>
                  <span className="h-14 w-14 rounded-2xl bg-[#0B1320] text-white grid place-items-center group-hover:bg-[#FF5A00] transition-colors">
                    <Icon size={22} strokeWidth={2} />
                  </span>
                </div>
                <h3 className="mt-8 text-2xl font-black tracking-tight">{s.t}</h3>
                <p className="mt-3 text-base leading-relaxed opacity-80">{s.d}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default How;
